import { AuthResponse } from 'store/ducks/auth/types';
import jwtDecode from 'jwt-decode';
import { PersonalInfo } from '../../store/ducks/statements/types';

const EIGHT_HOURS_IN_SECONDS = 28800;
export const BEXS_AUTH_TOKEN = '@bexs:auth-token';
export const BEXS_ACCOUNT_INFO = '@bexs:account-info';
export const BEXS_IS_FIRST_ACCESS_IN_THIS_DEVICE = '@bexs:is-first-access';

export interface AuthToken extends AuthResponse {
  expiresDate: number;
  email?: string;
}

export const serializeToken = (token: AuthResponse) => {
  if (token) {
    const authToken = {
      ...token,
      expiresDate: new Date().getTime() + EIGHT_HOURS_IN_SECONDS * 1000,
    };
    localStorage.setItem(BEXS_AUTH_TOKEN, JSON.stringify(authToken));
  }
  return null;
};

export const getToken = (): AuthToken =>
  JSON.parse(localStorage.getItem(BEXS_AUTH_TOKEN) as string);

export const getCompanyId = () => {
  const token = getToken();
  return (
    jwtDecode(token.access_token) as Record<
      string,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      any
    >
  )['https://bexs/pay/merchant'];
};

export const serializeAccountInfo = (accountInfo: PersonalInfo) =>
  localStorage.setItem(BEXS_ACCOUNT_INFO, JSON.stringify(accountInfo));

export const getAccountInfo = () => {
  const accountInfo = localStorage.getItem(BEXS_ACCOUNT_INFO);
  return accountInfo ? (JSON.parse(accountInfo) as PersonalInfo) : undefined;
};

export const deleteToken = () => {
  localStorage.removeItem(BEXS_AUTH_TOKEN);
  localStorage.removeItem(BEXS_ACCOUNT_INFO);
};

export const isAuthenticated = () => {
  const token = getToken();
  if (token) {
    const NOW = new Date().getTime();
    const { expiresDate } = token;
    if (NOW < expiresDate) {
      return true;
    }
  }
  return false;
};

export const getIsFirstAccessInThisDevice = () => {
  const getInfo = localStorage.getItem(BEXS_IS_FIRST_ACCESS_IN_THIS_DEVICE);
  if (!getInfo) {
    localStorage.setItem(BEXS_IS_FIRST_ACCESS_IN_THIS_DEVICE, 'false');
    return true;
  }
  return false;
};
